module.exports = __webpack_public_path__ + "img/C4.ebcb261f.webp";